// eslint-disable-next-line import/prefer-default-export
export const sanitizeSearchParams = (url) => {
  const queryParams = {};
  const decodedUrl = decodeURIComponent(url);
  const queryString = decodedUrl.split('?')[1];
  const params = new URLSearchParams(queryString);

  params.forEach((value, key) => {
    if (key === 'multipleBet') {
      // Extracting the multipleBet value
      const multipleBetString = value.replace('[{', '').replace('}]', '');
      const dataPairs = multipleBetString.split('},{');
      const dataArray = dataPairs.map(pair => {
        const [eventIdStr, runnerIdStr] = pair.split(',');
        const eventId = eventIdStr.split(':')[1]?.trim().replace(/[%]20/g, ' ');
        const runnerId = runnerIdStr.split(':')[1]?.trim().replace(/[%]20/g, ' ');
        return { eventId, runnerId };
      });
      queryParams[key] = dataArray;
    } else {
      queryParams[key] = value;
    }
  });

  return queryParams;
};